import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { filterTypesAgGrid } from '../../../constants/globals';

export default forwardRef((props, ref) => {
  const { values, statusTitle, off, clear } = props || ' ';

  const [filterState, setFilterState] = useState(off);

  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return filterState !== off;
      },
      doesFilterPass(params) {
        if (filterState === values[0]) return params?.data['active'] === true;
        if (filterState === values[1]) return params?.data['active'] === false;
      },
      getModel() {
        return filterTypesAgGrid.BOOLEAN;
      },
      setModel() {},
      resetFilter() {
        return setFilterState(off);
      },
    };
  });

  useEffect(() => props.filterChangedCallback(), [filterState, props]);

  return (
    <div>
      <div className="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
        <div className="d-flex gap-1">
          <label>{statusTitle}</label>
          <label>
            <b className="small-text">{filterState}</b>
          </label>
        </div>
        <div className="d-flex flex-row gap-4 mt-1">
          {values.map((value) => {
            const buttonStyle =
              filterState === value
                ? 'boolean-button-value-selected-style'
                : '';
            return (
              <button
                key={value}
                onClick={() => setFilterState(value)}
                className={`boolean-button-value-style text-center ${buttonStyle}`}
              >
                {value}
              </button>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-end p-2 ag-filter-apply-panel">
        <button
          onClick={() => setFilterState(off)}
          className="ag-standard-button ag-filter-apply-panel-button"
        >
          {clear}
        </button>
      </div>
    </div>
  );
});
